<template>
  <div>
    <div class="d-flex align-items-center flex-wrap mb-3">
      <lang-switch v-model="lang" :fields="translatable" />
      <small class="text-muted ml-auto">Shown on the site's team and coordinator pages</small>
    </div>

    <translatable-field
      v-for="field in fields"
      :key="field.key"
      :value="value[field.key]"
      :lang="lang"
      :label="field.label"
      :type="field.type"
      :read-only="readOnly"
      :maxlength="field.maxlength"
      @input="set(field.key, $event)"
    />
  </div>
</template>

<script>
import LangSwitch from "./LangSwitch";
import TranslatableField from "./TranslatableField";

/**
 * Block 6 of the employee form: the public profile, straight from users.metadata. In the old
 * admin each of these was 13 columns (sub_title_1..22, short_text_*, …) or, for publications and
 * membership, one textarea packed with `<hr>` and `EN:` markers; here it is one field per
 * attribute and one language switch for the block.
 *
 * Limits are the old admin's column widths — the site's layout was built around them.
 */
export const PROFILE_FIELDS = [
  { key: "position", label: "Position (signature on the team page)", type: "text", maxlength: 100 },
  { key: "short_description", label: "Short description", type: "textarea", maxlength: 255 },
  { key: "description", label: "Description", type: "wysiwyg" },
  { key: "practice", label: "Practice", type: "textarea", maxlength: 1000 },
  { key: "credo", label: "Credo", type: "textarea", maxlength: 512 },
  { key: "publications", label: "Publications", type: "wysiwyg" },
  { key: "membership", label: "Membership in organisations", type: "wysiwyg" },
];

export default {
  name: "EmployeeProfileContent",
  components: { LangSwitch, TranslatableField },
  props: {
    readOnly: { type: Boolean, default: false },
    // { position: { en: "", ... }, short_description: {...}, ... }
    value: { type: Object, required: true },
  },
  data() {
    return { lang: "en" };
  },
  computed: {
    fields() {
      return PROFILE_FIELDS;
    },
    translatable() {
      return PROFILE_FIELDS.map(({ key }) => this.value[key] || {});
    },
  },
  methods: {
    set(key, translations) {
      if (this.readOnly) return;
      this.$emit("input", { ...this.value, [key]: translations });
    },
  },
};
</script>
